import {GetNftRewardResponse, NftsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";
import { useQuery } from "@tanstack/react-query";

async function fetchDevourLootboxNftRewards(nftTrackerId: string): Promise<GetNftRewardResponse> {
    return await new NftsApi(getConfig()).getDevourLootboxNftRewards({
        id: nftTrackerId,
    });
}

function getDevourLootboxNftRewardsQuery(nftTrackerId: string) {
    return {
        queryKey: ["devour-lootbox-nft-rewards", nftTrackerId],
        queryFn: () => fetchDevourLootboxNftRewards(nftTrackerId),
        keepPreviousData: true,
        staleTime: 30 * 24 * 60 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(nftTrackerId),
    } as const;
}

export function useGetDevourLootboxNftRewards(nftTrackerId: string) {
    return useQuery(getDevourLootboxNftRewardsQuery(nftTrackerId));
}